import './index.scss';
import rewardTable2 from '@/static/images/rewardTable2.png';
import { Image, Button } from 'react-bootstrap';
function Read({onRead}) {

    return (
        <div className='read-book flex-column'>
            <div className='text-left read-title'>Read to earn $16DAO</div>
            <div className='text-left read-content'>Hold tokens in your wallet and earn by reading. At the end of each novel, when you tap the "Finish” button, system will check whether your wallet is holding $16DAO or not; and according to the number of tokens held, rewards will be issued according to the level.</div>
            <Image src={rewardTable2} className="read-img" />
            <div className='text-left read-btn' >
                <Button onClick={e => onRead()}>Read</Button>
            </div>
        </div>
    )
}
export default Read;